module.exports = __webpack_public_path__ + "img/img2.59d5950c.png";